// extracted by mini-css-extract-plugin
export default {"wrapper":"modalForm_wrapper__SYnKR","actions":"modalForm_actions__XZR4n"};